import { render, staticRenderFns } from "./TabBoxContent.vue?vue&type=template&id=4f60d9ec&scoped=true&lang=pug&"
import script from "./TabBoxContent.vue?vue&type=script&lang=js&"
export * from "./TabBoxContent.vue?vue&type=script&lang=js&"
import style0 from "./TabBoxContent.vue?vue&type=style&index=0&id=4f60d9ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f60d9ec",
  null
  
)

export default component.exports